import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from 'components/Icons/types'

const Svg = styled.svg`
  fill: #1976d2;
  width: 19px;
  height: 19px;
`

export const DownloadIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg viewBox="0 0 24 24" className={className}>
      <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"></path>
    </Svg>
  )
}
